/** Mirrors the API's attachment ALLOWED_EXTENSIONS. */
const EVIDENCE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'csv', 'xls', 'xlsx'] as const;

/** The same cap as the app's other attachment uploads. */
const EVIDENCE_MAX_MB = 5;

export const EVIDENCE_ACCEPT = EVIDENCE_EXTENSIONS.map((ext) => `.${ext}`).join(',');

const ALLOWED_LABEL = EVIDENCE_EXTENSIONS.map((ext) => ext.toUpperCase()).join(', ');

export function extensionOf(name: string): string {
  const dot = name.lastIndexOf('.');
  return dot === -1 ? '' : name.slice(dot + 1).toLowerCase();
}

export function evidenceFileError(file: File): string | null {
  if (!(EVIDENCE_EXTENSIONS as readonly string[]).includes(extensionOf(file.name))) {
    return `${file.name} can't be attached. Allowed types: ${ALLOWED_LABEL}.`;
  }
  if (file.size > EVIDENCE_MAX_MB * 1024 * 1024) {
    return `${file.name} is larger than ${EVIDENCE_MAX_MB} MB.`;
  }
  return null;
}
